import ReportingApi from './ReportingApi';
export default ReportingApi;
